import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Div } from '@driftt/tide-core'
import List from './List'

import './NewTabs.css'

const mapStateToProps = state => {
  return {
    contactEvents: state.__CRM.filterBuilder.events
  }
}

class ContactEvents extends Component {
  constructor(props) {
    super(props)

    this.state = {
      events: null
    }
  }

  componentDidMount() {
    this.formatData()
  }

  formatData = () => {
    const { contactEvents } = this.props

    this.setState({
      events: [{
        title: 'Events',
        properties: contactEvents
      }]
    })
  }
  render() {
    const { onSelectProp } = this.props
    const { events } = this.state

    return (
      <Div className="contact-properties--container">
        <Div className="filter-builder--tabs">
          {!!events && 
            <List 
              displayKey="name" 
              filterKey="name" 
              onSelect={onSelectProp} 
              helpText={'Events as we process them inside Drift'}
              title={'Contact Tags'}
              properties={events}
              hideType={true}
              subEntityType={'events'}
            />
          }
        </Div>
      </Div>
    )
  }
}

export default connect(mapStateToProps)(ContactEvents)
